/**
 * Baixar a foto ou o vídeo do chat sem sair da conversa.
 *
 * O `download` de um `<a>` só vale quando o arquivo vem da mesma origem da página. Aqui
 * não vem: a mídia é servida pela API (`api.mymaxx…`) e a conversa mora no painel ou no
 * chat (`painel.mymaxx…`, `mymaxx…`). Cross-origin, o navegador **ignora** o atributo e
 * simplesmente navega para o arquivo — foi o que aconteceu com o atendente, que clicava em
 * baixar e perdia o atendimento de vista (29/09). Em desenvolvimento não aparecia, porque
 * ali tudo sai da mesma porta.
 *
 * Buscando o arquivo e entregando um blob da própria origem, o `download` volta a valer.
 */
/** Nome de arquivo sem o que atrapalha o sistema de arquivos. */
function nomeSeguro(nome) {
    return nome.replace(/[\\/:*?"<>|]/g, '_').slice(0, 120) || 'arquivo';
}
function salvarBlob(blob, nome) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeSeguro(nome);
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Sem o adiamento, o Safari cancela o download ao revogar a URL no mesmo instante.
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
/**
 * Baixa a mídia. Devolve `false` quando não foi possível buscar o arquivo, para a tela
 * poder avisar em vez de fingir que baixou.
 */
export async function baixarMidia(url, nomeOriginal, { perguntarOnde = false } = {}) {
    let blob;
    try {
        const resposta = await fetch(url);
        if (!resposta.ok)
            return false;
        blob = await resposta.blob();
    }
    catch {
        // URL assinada vencida, rede caída: quem chamou decide o que dizer.
        return false;
    }
    const nome = nomeSeguro(nomeOriginal);
    if (perguntarOnde && typeof navigator !== 'undefined' && 'canShare' in navigator) {
        const arquivo = new File([blob], nome, { type: blob.type });
        // `canShare` com arquivos é o teste que importa: há navegador com `share` que recusa
        // arquivo, e nesse caso a folha nem abre.
        if (navigator.canShare?.({ files: [arquivo] })) {
            try {
                await navigator.share({ files: [arquivo] });
                return true;
            }
            catch (erro) {
                // Cancelar a folha é escolha da pessoa, não erro: não cai para o download por
                // baixo dos panos, senão o arquivo apareceria mesmo depois de ela desistir.
                if (erro instanceof DOMException && erro.name === 'AbortError')
                    return true;
                // Qualquer outra recusa cai no download comum logo abaixo. O caso real é o
                // Safari do iPhone, que exige `share()` logo depois do toque e às vezes considera
                // que a espera do arquivo consumiu esse crédito — melhor baixar do que não fazer
                // nada.
            }
        }
    }
    salvarBlob(blob, nome);
    return true;
}
//# sourceMappingURL=baixar-midia.js.map